import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3acc62e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_PlayCircleOutlined = _resolveComponent("PlayCircleOutlined")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 东数西算解决方案 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString('支持以极低成本将业务数据在线传输至西部数据中心，10分钟传输10TB数据，' +
          '降低企业对数据中心的投资运营成本，更好地为数字化发展赋能。'))
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_space, {
        size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.localTo('https://dtexpress.galaxy-future.com/#/login')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 免费体验 ")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$Store.Page().openModal('modalFormCollection','demo')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 预约咨询 ")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_2 button_n_2_w",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$Store.Page().openModal('modalVideo',$data.href.video)))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_PlayCircleOutlined)
            ]),
            default: _withCtx(() => [
              _createTextVNode(" 观看视频 ")
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size"])
    ])
  ]))
}